import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

export function CustomersPage({
  activeOrders,
  newCustomerName,
  setNewCustomerName,
  createCustomer,
  selectOrder,
  calculateOrderTotal,
}) {
  return (
    <div className="space-y-4">
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <h3 className="font-medium mb-3">Agregar Cliente</h3>
        <div className="flex gap-2">
          <Input
            placeholder="Nombre del cliente"
            value={newCustomerName}
            onChange={(e) => setNewCustomerName(e.target.value)}
          />
          <Button onClick={createCustomer}>
            <Plus size={18} />
          </Button>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <h3 className="font-medium mb-3">Clientes Activos</h3>
        <div className="space-y-3">
          {activeOrders
            .filter(order => order.type === 'customer')
            .map(order => (
              <div key={order.id} className="border rounded-md overflow-hidden">
                <div className="bg-gray-50 p-3">
                  <h4 className="font-medium">Cliente: {order.name}</h4>
                </div>
                <div className="p-3">
                  <p className="text-sm text-gray-500 mb-2">
                    {order.items.length} productos | ${calculateOrderTotal(order).toFixed(2)}
                  </p>
                  <div className="space-y-1">
                    {order.items.slice(0, 2).map((item, index) => (
                      <p key={index} className="text-sm">
                        {item.quantity}x {item.productName}
                      </p>
                    ))}
                    {order.items.length > 2 && (
                      <p className="text-sm text-gray-500">
                        Y {order.items.length - 2} más...
                      </p>
                    )}
                  </div>
                </div>
                <div className="bg-gray-50 p-3">
                  <Button 
                    className="w-full" 
                    onClick={() => selectOrder(order)}
                  >
                    Seleccionar
                  </Button>
                </div>
              </div>
            ))}
            
          {activeOrders.filter(order => order.type === 'customer').length === 0 && (
            <p className="text-center text-gray-500 py-4">No hay clientes activos</p>
          )}
        </div>
      </div>
    </div>
  );
}